import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import {
  Drawer,
  DrawerOverlay
} from '@chakra-ui/react'
import {
  MODAL_SECTION,
  SUCCEEDED
} from 'utils/constants'
import {
  isAuth,
  isNotMobile,
  showCoordParams
} from 'utils/helpers'
import { Content } from 'components/Content/BlogModal/Content'
import { ContentForBlogPreview } from 'components/Content/BlogModal/ContentForBlogPreview'
import {
  authSelectors,
  handleOpenModal,
  setOpenPopupBlogs,
  setPosts,
  setComments,
  setBlogParent,
  setHideNotification,
  setHideChat,
  setCloseAllDrawers,
  usersSelectors
} from 'store'

export const BlogModal = () => {
  const dispatch = useDispatch()
  const {
    activeProfile,
    blogRepostData,
    blogRepostParent,
    adminNotifications,
    blogParent,
    chosenBlogIndex,
    closeAllDrawers,
    comments,
    commentsOption,
    getCommentsStatus,
    getPostsStatus,
    getUserProfileStatus,
    hideNotification,
    postCommentsStatus,
    putCommentsStatus,
    posts,
    profileItem,
    openPopupBlogs,
    subscribeToProfileStatus,
    chosenNotifBlog,
    postsOption,
    newPostsOption
  } = useSelector(usersSelectors)
  const { signInStatus } = useSelector(authSelectors)

  const drawerRef = useRef()

  const [widen, setWiden] = useState(false)
  const [widenAnimation, setWidenAnimation] = useState(false)
  const [animateOut, setAnimateOut] = useState(false)
  const [askToSignUp, setAskToSignUp] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [hoveringChevron, setHoveringChevron] = useState(false)
  const [disableOverlayClick, setDisableOverlayClick] = useState(false)

  const isLoggedIn = signInStatus === SUCCEEDED || isAuth()

  const animateMarkerFilter = (isOpen) => dispatch(handleOpenModal({
    isOpen,
    section: MODAL_SECTION.RightSection
  }))

  const closeDrawer = () => {
    setWidenAnimation(true)
    setWiden(false)
    setAnimateOut(true)
    setDisableOverlayClick(true)

    if (postsOption.type !== 'marker') {
      sessionStorage.removeItem('postId')
    }

    dispatch(setHideNotification(false))
    dispatch(setHideChat(false))

    setTimeout(() => {
      setAnimateOut(false)
      dispatch(setOpenPopupBlogs(false))
      setDisableOverlayClick(false)

      setTimeout(() => {
        if (
          document.querySelectorAll('.chakra-modal__content').length === 0
          && postsOption.type !== 'marker'
        ) {
          showCoordParams(setSearchParams)
        }
      }, 200)

      dispatch(setPosts([]))
      dispatch(setComments([]))
      dispatch(setBlogParent([]))
    }, 1500)
  }

  useEffect(() => {
    if (
      isLoggedIn
      && getUserProfileStatus === SUCCEEDED
      && sessionStorage.getItem('postId')
    ) {
      setAskToSignUp(false)

      try {
        document.querySelector('button[name="profile-pane-back-btn"]').click()
      } catch {
        //
      }
    }
  }, [isLoggedIn, getUserProfileStatus])

  useEffect(() => {
    if (closeAllDrawers) {
      closeDrawer()
    }
  }, [closeAllDrawers])

  useEffect(() => {
    setTimeout(() => setWidenAnimation(true), 500)
    setHoveringChevron(false)
  }, [])

  return (
    <Drawer
      id="blog-drawer"
      finalFocusRef={drawerRef}
      isOpen={openPopupBlogs}
      onClose={() => {
        if (isLoggedIn) {
          closeDrawer()
        }
      }}
      placement={postsOption.type === 'marker' || isNotMobile() ? 'bottom' : 'end'}
      size="sm"
      closeOnEsc={false}
      closeOnOverlayClick={isLoggedIn}
      boxShadow="2xl"
      blockScrollOnMount={false}
    >
      <DrawerOverlay
        id="blog-modal-overlay"
        zIndex="1300"
        background="transparent"
        onClick={() => {
          if (!disableOverlayClick) {
            if (isLoggedIn) {
              dispatch(setCloseAllDrawers(true))
              setTimeout(() => dispatch(setCloseAllDrawers(false)), 850)
              document.querySelector('div#custom-popup-overlay')?.click()
            } else if (!isLoggedIn && !askToSignUp) {
              setAskToSignUp(true)
            }
          }
        }}
      />
      <Content
        activeProfile={activeProfile}
        adminNotifications={adminNotifications}
        animateMarkerFilter={animateMarkerFilter}
        animateOut={animateOut}
        askToSignUp={askToSignUp}
        blogParent={blogParent}
        chosenBlogIndex={chosenBlogIndex}
        chosenNotifBlog={chosenNotifBlog}
        closeDrawer={closeDrawer}
        comments={comments}
        commentsOption={commentsOption}
        getCommentsStatus={getCommentsStatus}
        getPostsStatus={getPostsStatus}
        hideNotification={hideNotification}
        hoveringChevron={hoveringChevron}
        isLoggedIn={isLoggedIn}
        postCommentsStatus={postCommentsStatus}
        posts={posts}
        postsOption={postsOption}
        profileItem={profileItem}
        putCommentsStatus={putCommentsStatus}
        setAskToSignUp={setAskToSignUp}
        setHoveringChevron={setHoveringChevron}
        setWiden={setWiden}
        setWidenAnimation={setWidenAnimation}
        subscribeToProfileStatus={subscribeToProfileStatus}
        newPostsOption={newPostsOption}
        widen={widen}
        widenAnimation={widenAnimation}
      />

      {
        blogRepostData.length
          ? (
            blogRepostData.map((data) => (
              <ContentForBlogPreview
                activeProfile={activeProfile}
                animateMarkerFilter={animateMarkerFilter}
                adminNotifications={adminNotifications}
                blogRepostData={blogRepostData}
                blogRepostParent={blogRepostParent}
                chosenBlogIndex={chosenBlogIndex}
                chosenNotifBlog={chosenNotifBlog}
                closeDrawer={closeDrawer}
                comments={comments}
                commentsOption={commentsOption}
                data={data}
                getCommentsStatus={getCommentsStatus}
                getPostsStatus={getPostsStatus}
                hoveringChevron={hoveringChevron}
                parentAnimateOut={animateOut}
                postCommentsStatus={postCommentsStatus}
                postsOption={postsOption}
                profileItem={profileItem}
                putCommentsStatus={putCommentsStatus}
                setHoveringChevron={setHoveringChevron}
                setWiden={setWiden}
                setWidenAnimation={setWidenAnimation}
                subscribeToProfileStatus={subscribeToProfileStatus}
                widen={widen}
                widenAnimation={widenAnimation}
                newPostsOption={newPostsOption}
              />
            ))
          ) : ''
      }
    </Drawer>
  )
}
